// The Return / Discount shortcut: 'Also issue the credit note now'. Shown only while the credit note model is ON. Greyed (never hidden) with the reason while the order has no issued invoice
// (one cheap read of the order's credit note sources: reconcile.kind === 'invoice'). The host sends issue_credit_note:true + credit_note_date in its POST body; the API issues THAT event's line only.
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../../services/api';
import { CheckField } from '../../form/FormField';
import useActionLabel from '../../../i18n/useActionLabel';
import useAvoirModel from './avoirModelStore';

export default function IssueNowCheck({ operationId, checked, onChange }) {
  const { t } = useTranslation('avoir'); const al = useActionLabel(); const on = useAvoirModel();
  const [invoiced, setInvoiced] = useState(null);   // null = unknown yet
  useEffect(() => {
    if (on !== true || !operationId || !api.getAvoirSources) return undefined;
    let live = true; Promise.resolve(api.getAvoirSources(operationId)).then(r => live && setInvoiced(r?.reconcile?.kind === 'invoice')).catch(() => live && setInvoiced(false));
    return () => { live = false; };
  }, [on, operationId]);
  if (on !== true) return null;
  const blocked = invoiced === false;
  return (
    <div data-testid="issue-cn-now" data-blocked={blocked ? 'yes' : undefined} title={blocked ? t('shortcut.noInvoice') : undefined}>
      <CheckField checked={checked && !blocked} disabled={blocked} onChange={onChange} label={al('issueCreditNoteAlso')} help={blocked ? t('shortcut.noInvoice') : t('shortcut.tip')} />
      {blocked && <div className="rec-mut" data-testid="issue-cn-now-why">{t('shortcut.noInvoice')}</div>}
    </div>
  );
}
